export default class Warning {
  constructor (message) {
    this.message = message
  }
}



// WEBPACK FOOTER //
// ./~/rctui/utils/warning.js